<div class="subheader with-padding flgrow" style="position: relative">
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-8 maxw600">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="input-group">
            <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblQuicksearch' | translate }}"
              [(ngModel)]="searchTerm" autocomplete="off" (keyup.enter)="onSearchFilter()" />
            <div class="input-group-append">
              <button type="button" class="btn btn-primary" (click)="onSearchFilter()" aria-label="Center Align">
                <em class="fa fa-search" aria-hidden="true"></em>
              </button>
            </div>
          </div>
        </div>
        <div class="ml-2 advanced-search-box">
          <button type="button" class="btn btn-primary" (click)="onSearch()" aria-label="Center Align">
            <em class="fa fa-search-plus" aria-hidden="true"></em>
          </button>
          <div class="searchbox card fix lt width800px" *ngIf="isAdvanceSearch">
            <div class="row mt-3">

              <div class="col-4">
                <label translate>lblRegNumber</label>
                <input class="form-control" type="text" name="licensePlate"
                  [(ngModel)]="service.widgetAppointmentRequest.licensePlate" maxlength="10" autocomplete="off" />
              </div>
              <div class="col-4">
                <label translate>lblAppointmentStatus</label>
                <select class="form-control" [(ngModel)]="service.widgetAppointmentRequest.statusId" name="id">
                  <option selected translate [ngValue]=null>lblSelectStatus</option>
                  <option *ngFor="let status of AppointmentStatusList" [ngValue]="status.id">
                    {{status.name}}
                  </option>
                </select>
              </div>
              <div class='col-4'>
                <label translate>lblCreatedDateRange</label>
                <div class="date">
                  <input bsDaterangepicker name="CreatedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
                  [(ngModel)]="createdDate" />
                </div>
              </div>
            </div>

            <div class="mb-4"></div>

            <div class="row">
              <div class="col-4">
                <label translate>lblSearchByCustomerName</label>
                <input class="form-control" type="text" name="customerName"
                  [(ngModel)]="service.widgetAppointmentRequest.customerName" maxlength="80" autocomplete="off" />
              </div>
              <div class="col-4">
                <label translate>lblDealer</label>
                <select class="form-control" [(ngModel)]="service.widgetAppointmentRequest.dealerId" name="id">
                  <option selected translate [ngValue]=null>lblSelectDealer</option>
                  <option *ngFor="let dealer of dealerList" [ngValue]="dealer.value">
                    {{dealer.text}}
                  </option>
                </select>
              </div>
              <div class="col-4">
                <label translate>lblType</label>
                <select class="form-control" [(ngModel)]="service.widgetAppointmentRequest.typeId" name="id">
                  <option selected translate [ngValue]=null>lblSelectType</option>
                  <option *ngFor="let type of typeStatusList" [ngValue]="type.id">
                    {{type.name}}
                  </option>
                </select>
              </div>
            </div>

            <div class="mb-4"></div>

            <div class="row">
              <div class='col-4'>
                <label translate>lblBookedDateRange</label>
                <div class="date">
                  <input bsDaterangepicker name="BookedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
                  [(ngModel)]="bookingDate" />
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col text-left">
                <button type="submit" (click)="OpenSaveSearchModal(SaveSearchContent)" aria-label="Center Align"
                  class="btn btn-primary mr-sm-2 mb-1" translate>lblSaveFilter
                </button>
              </div>
              <div class="col-auto me-auto text-right">
                <button type="submit" (click)="AdvanceSearchSubmit()" aria-label="Center Align"
                  class="btn btn-primary mr-sm-2" translate>lblApply
                </button>
                <button (click)="onReset()" aria-label="Center Align" class="btn btn-outline-tertiary mr-sm-2"
                  translate>lblReset
                </button>
                <button (click)="onClose()" aria-label="Center Align" class="btn btn-outline-tertiary"
                  translate>lblClose
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-auto pl-0">
      <button type="submit" (click)="OpenSavedSearchListPopup()" class="btn btn-primary" translate
        aria-label="Center Align">lblSavedFilters</button>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
      <ng-select placeholder="{{ 'lblAppointmentStatus' | translate }}" [(ngModel)]="SelectedAppointmentStatus"
        (change)="AppointmentStatusChange($event)">
        <ng-option *ngFor="let status of AppointmentStatusList" [value]="status.id">
          {{status.name}}
        </ng-option>
      </ng-select>
    </div>
    <div class="col-3 col-lg-3 ml-auto d-flex flex-sm-row flex-column justify-content-end">
      <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" (click)="onRefresh()"
        aria-label="Center Align">
        <em class="fas fa-sync fa-lg"></em>
      </a>
    </div>
  </div>
</div>

<div class="prel container">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex justify-content-between" translate>
          lblWidgetAppointmentRequests
          <div class="font16 fontbold">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
            totalCount
            }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>

        <div class="table-responsive max-h290" infinite-scroll [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th style="width: 7%" scope="col" translate class="">
                  lblBookedDate
                </th>
                <th style="width: 15%" scope="col" sortable="licensePlate" (sort)="onSort($event)" translate>
                  lblRegNumber
                </th>
                <th style="width: 15%" scope="col" sortable="WidgetAppointmentNo" (sort)="onSort($event)" translate>
                  lblReferenceNo
                </th>
                <th style="width: 15%" class="ST" scope="col" sortable="customerName" (sort)="onSort($event)" translate>
                  lblCustomer
                </th>
                <th style="width: 10%" scope="col" sortable="DealerName" (sort)="onSort($event)" translate>
                  lblDealersName
                </th>
                <th style="width: 20%" scope="col" translate class="">
                  lblType
                </th>
                <th style="width: 8%" scope="col" translate class="" *ngIf="IsRentalCarActive">
                  lblRentalCar
                </th>
                <th style="width: 5%" scope="col" sortable="createdDate" (sort)="onSort($event)" translate>
                  lblCreatedDate
                </th>
                <th style="width: 120px" scope="col" translate class="text-center">
                  lblStatus
                </th>
                <th scope="col" style="width: 150px; min-width: 100px" translate class="text-center">
                  lblAction
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="appointmentList?.length > 0; else load_else">
                <tr *ngFor="let appointment of appointmentList; let i = index">
                  <td>{{ appointment.rowNumber }}</td>
                  <td>
                    <ngb-highlight [result]="appointment.bookedDateTime | date: 'short'">
                    </ngb-highlight>
                  </td>

                  <td>
                    <div class="flmid">
                      <div class="licplate LPNo d-flex">
                        <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                        {{ appointment.licensePlate }}
                      </div>
                      <div class="imgWid">
                        <img af-brand-logo [data-code]="appointment.brandCode" data-type="BRAND"
                        [ngClass]="appointment.brand ? appointment.brand.name + '-icon common' : 'common'" [title]="appointment.brandCode"
                          class="brandicon" alt="img" />
                      </div>
                    </div>
                    <div class="mt-1">
                      <ngb-highlight class="flmid semibold fs-12px lh-16px" [result]="appointment.model">
                      </ngb-highlight>
                    </div>
                  </td>
                  
                  <td>{{ appointment.widgetAppointmentNo }}</td>

                  <td>
                    <ngb-highlight class="fs-16px semibold lh-18px d-block" [result]="appointment.customerName">
                    </ngb-highlight>
                    <div class="d-flex align-items-center mt-1 fs-12px lh-16px" *ngIf="appointment.mobileNo">
                      <em _ngcontent-xdg-c220="" class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                      <span class="fs-12px" *ngIf="appointment.mobileCode">{{ appointment.mobileCode }}-</span>
                      <ngb-highlight class="fs-12px" [result]="appointment.mobileNo">
                      </ngb-highlight>
                    </div>
                    <div class="d-flex align-items-center" *ngIf="appointment.email">
                      <em _ngcontent-xdg-c220="" class="fas fa-envelope fs-10px fa-lg mr-2 clr666"></em>
                      <ngb-highlight class="fs-12px" [result]="appointment.email">
                      </ngb-highlight>
                    </div>
                  </td>

                  <td>{{ appointment.dealerName }}</td>

                  <td>
                    <div class="flmid">
                      <div class="color" [style.background-color]="appointment.typeColor"></div>
                      <div>
                        {{ appointment.typeName | translate }}
                      </div>
                    </div>
                  </td>
                  <td *ngIf="IsRentalCarActive">
                    <em class="fas fa-check fa-lg" *ngIf="appointment.isRentalCarRequire === true"></em>
                    <em class="fas fa-times text-danger fa-lg cursordisable" *ngIf="appointment.isRentalCarRequire === false"></em>
                  </td>
                  <td>{{ appointment.createdDateTime | date: "short" }}</td>

                  <td class="align-items-center">
                    <div class="other-styles text-center" [ngClass]="
                    appointment.statusId === 1
                      ? 'pending-background'
                      : 'reject-background'
                      ">
                      {{ appointment.statusName }}
                    </div>
                  </td>

                  <td class="nowrap text-center">
                    <ng-container>
                      <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" *ngIf="userRoleRightsDetails.canEdit && appointment.statusId === 1"
                        (click)="onEdit(appointment)">
                        <em class="fas fa-pencil-alt fa-lg  far fa-eye fa-lg"></em>
                      </a>
                      <a class="btn btn-ico" ngbTooltip="{{'lblView' | translate}}" *ngIf="userRoleRightsDetails.canView && appointment.statusId === 2"
                        (click)="onEdit(appointment)">
                        <em class="far fa-eye fa-lg"></em>
                      </a>
                    </ng-container>

                    <span [class.invisible]="!(appointment.statusId === 2)" class="ico-div"></span>
                    <ng-container>
                      <a [class.invisible]="!(appointment.statusId === 2)" class="btn btn-ico"
                        *ngIf="userRoleRightsDetails.canDelete" (click)="DeleteAppointment(appointment)"
                        ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert">
                        <em class="far fa-trash-alt fa-lg"></em>
                      </a>
                    </ng-container>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="12" class="no-record" translate>
                    lblNoRecordsFound
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="d-flex" style="position: relative">
  <div class="subheader with-padding flgrow custom-style" *ngFor="let item of typeStatusList"
    [style.borderLeft]="'5px solid ' + item.colorCode">
    <div class="d-flex justify-content-between mt-1 mb-1">
      <p translate>{{ item.labelKey }}</p>
      <p>{{ item.count }}</p>
    </div>
  </div>
</div>
<ng-template #SaveSearchContent let-modal>
  <div class="modal-header">
    <h2 class="modal-title" translate>lblSaveFilter</h2>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">

      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body p-0 ">
    <div class="popup-vcenter ">
      <div class="flgrow">
        <div class="pad15">
          <div class="form-row">
            <div class='col-5'>
              <label translate>lblSearchName</label><strong class="mlt6 required"> * </strong>
              <div class="">
                <input class="form-control" type="text" name="SearchName" [formControl]="control"
                  [(ngModel)]="saveSearchFilter.filterName" maxlength="200" autocomplete="off"
                  placeholder="{{ 'lblEnterSearchName' | translate }}" />
                <div *ngIf="!saveSearchFilter.filterName && control.touched" style="color: red;"
                  class="cst-validation-msg">
                  <em class="fa fa-exclamation-circle" aria-hidden="true">&nbsp;&nbsp;</em><span
                    translate>lblSearchNameRequired</span>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="form-row">
            <div class="col-12">
              <p class="title16 mb-2" translate>lblParameterValues</p>
              <div class="row">
                <div class='col-4 mb-2' *ngFor="let search of saveSearchFilter.saveSearchArray">
                  <div class="px-3">
                    <em class="fa fa-chevron-right mr-2"></em>
                    <span class="bold">{{search.searchColumnName | translate}}</span> :
                    {{search.searchActualValue}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" [disabled]="!saveSearchFilter.filterName" class="btn btn-primary mr-sm-2" translate
      (click)="control.markAsTouched();SaveAdvanceSearchFilter();" aria-label="Center Align">lblSave</button>
    <button (click)="modal.dismiss(false)" class="btn btn-secondary" aria-label="Center Align"
      translate>lblCancel</button>
  </div>
</ng-template>
